import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCostItemLinked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#0763FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1216 3.25293C9.42529 3.25293 8.75747 3.52955 8.26507 4.02195L6.93851 5.34851C6.79206 5.49496 6.79206 5.73239 6.93851 5.87884C7.08496 6.02529 7.32239 6.02529 7.46884 5.87884L8.7954 4.55228C9.14714 4.20054 9.62421 4.00293 10.1216 4.00293C10.6191 4.00293 11.0961 4.20054 11.4479 4.55228C11.7996 4.90402 11.9972 5.38108 11.9972 5.87852C11.9972 6.37595 11.7996 6.85302 11.4479 7.20476L10.1213 8.53132C9.97487 8.67777 9.97487 8.91521 10.1213 9.06165C10.2678 9.2081 10.5052 9.2081 10.6517 9.06165L11.9782 7.73509C12.4706 7.2427 12.7472 6.57487 12.7472 5.87852C12.7472 5.18217 12.4706 4.51434 11.9782 4.02195C11.4858 3.52955 10.818 3.25293 10.1216 3.25293Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.85465 6.1405C10.0012 6.28684 10.0014 6.52427 9.85505 6.67083L6.67692 9.85364C6.53058 10.0002 6.29314 10.0004 6.14659 9.85403C6.00004 9.70769 5.99986 9.47025 6.1462 9.3237L9.32432 6.14089C9.47066 5.99433 9.7081 5.99416 9.85465 6.1405Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.87982 6.93757C6.02626 7.08401 6.02626 7.32145 5.87982 7.4679L4.55325 8.79446C4.20151 9.1462 4.00391 9.62326 4.00391 10.1207C4.00391 10.6181 4.20151 11.0952 4.55325 11.4469C4.90499 11.7987 5.38206 11.9963 5.87949 11.9963C6.1258 11.9963 6.36969 11.9478 6.59725 11.8535C6.82481 11.7593 7.03157 11.6211 7.20574 11.4469L8.5323 10.1204C8.67874 9.97393 8.91618 9.97393 9.06263 10.1204C9.20908 10.2668 9.20908 10.5043 9.06263 10.6507L7.73607 11.9773C7.49226 12.2211 7.20281 12.4145 6.88426 12.5464C6.56571 12.6784 6.22429 12.7463 5.87949 12.7463C5.18314 12.7463 4.51532 12.4697 4.02292 11.9773C3.53053 11.4849 3.25391 10.8171 3.25391 10.1207C3.25391 9.42435 3.53053 8.75652 4.02292 8.26413L5.34949 6.93757C5.49593 6.79112 5.73337 6.79112 5.87982 6.93757Z",
			fill: "white"
		})
	]
});
export default SvgCostItemLinked;
